// extracted by mini-css-extract-plugin
export default {"descriptionCharCounter":"ActivityDescription__descriptionCharCounter___j5rDQ"};